/**
 * Ink and tint here are a literal #FFFFFF, not the `white` token, matching Header.style.tsx.
 *
 * Dark mode regenerates the theme rather than swapping a stylesheet: it maps `white` to
 * near-black (dark-mode-utils, `case 'white'`) but leaves `primary` alone (role `fixed`), so on
 * this header `tw:text-white` renders at 1.26:1 — illegible (PB-4563).
 */

// Outer pill container — clickable link or button
export const pillClasses = [
  'tw:inline-flex tw:items-center tw:gap-micro',
  'tw:rounded-full',
  'tw:bg-[#FFFFFF]/15',
  'tw:px-small tw:py-nano',
  'tw:min-h-[2.75rem]',
  'tw:cursor-pointer',
  'tw:no-underline',
  'tw:transition-colors tw:duration-150',
  'tw:hover:bg-[#FFFFFF]/25',
  'tw:border-0',
].join(' ');

// Pulsing status dot
export const dotBaseClasses = [
  'tw:w-2 tw:h-2',
  'tw:rounded-full',
  'tw:animate-dot-pulse',
  'tw:shrink-0',
].join(' ');

export const dotActiveClasses = 'tw:bg-accent';
export const dotExpiredClasses = 'tw:bg-warn';

// Garage name — desktop only
export const garageNameClasses = [
  'tw:hidden tw:md:inline',
  'tw:text-14 tw:font-regular',
  'tw:text-[#FFFFFF]/80',
  'tw:truncate',
  'tw:max-w-[12rem]',
].join(' ');

// Duration text — desktop only
export const durationClasses = [
  'tw:hidden tw:md:inline',
  'tw:text-14 tw:font-regular',
  'tw:text-[#FFFFFF]/80',
  'tw:shrink-0',
].join(' ');

// Separator dot — desktop only
export const separatorClasses = ['tw:hidden tw:md:inline', 'tw:text-[#FFFFFF]/50', 'tw:text-14'].join(
  ' '
);

// Mobile text — hidden on desktop
export const mobileTextClasses = [
  'tw:md:hidden',
  'tw:text-14 tw:font-medium',
  'tw:text-[#FFFFFF]',
  'tw:leading-1',
].join(' ');

// Desktop text — hidden on mobile
export const desktopTextClasses = [
  'tw:hidden tw:md:inline',
  'tw:text-14 tw:font-medium',
  'tw:text-[#FFFFFF]',
  'tw:leading-1',
].join(' ');
